import $ from 'jquery';
import { getNavHeight } from './pinNav';
import { getNewPageTile } from './pageTile';

export const scrollToSection = (sectionHash, waitCounter = 1, waitCounterMax = 10, waitTime = 1000) => {
    const $sectionHash = $(sectionHash);
    if (!$sectionHash.length) return;

    var tabletOffset = 0;
    if (vendor.pageInfo.getLayout() === 'Tablet') {
        tabletOffset = 30;
    }
    const position = isMobilePage() ? $sectionHash.position().top : $sectionHash.offset().top + tabletOffset;
    const offset = $sectionHash.outerHeight() - $sectionHash.height();
    const navHeight = getNavHeight();
    const navWrapperHeight = $('.model-nav-wrapper').outerHeight(true);
    $('.crux-sub-nav__link.model-nav__link a').removeClass('hovered');

    if (isMobilePage() || navWrapperHeight > 0 || waitCounter++ >= waitCounterMax) {
        $("html, body").animate({ scrollTop: position - navHeight + offset + (waitCounter >= waitCounterMax && !isMobilePage() ? 60 : 0) });
    } else {
        window.setTimeout(()=>scrollToSection(sectionHash, waitCounter), waitTime);
    }
};

export const isMobilePage = () => {
    return vendor.pageInfo.getLayout() === 'Mobile';
};

export default function () {
    const initState = document.location.pathname + document.location.search + document.location.hash;
    window.history.replaceState({'hrefState': initState}, document.title, initState);
    let prevState = initState;

    $('.crux-sub-nav__link.model-nav__link:not(.force-link) a[href], button.js-scroll-to-section').on('click', function(event) {
        event.preventDefault();
        const hash = $(this).data('target');
        const href = $(this).data('href');
        const state = href + hash;
        if (hash && href && prevState != state) {
            history.pushState({'hrefState': state}, getNewPageTile(), state);
            window.location.replace(hash);
            prevState = state;
        }
        scrollToSection(hash);
        $(this).addClass('hovered');
    });

    if (vendor.pageInfo.getLayout() === 'Tablet') {
        $('body').bind('touchmove', function(e) {
            $('.crux-sub-nav__link.model-nav__link a').removeClass('hovered');
        });
    }

    if (vendor.pageInfo.getLayout() === 'Desktop') {
        $('.crux-sub-nav__link.model-nav__link').on('mouseenter', function(e) {
            $('.crux-sub-nav__link.model-nav__link a').removeClass('hovered');
            $(e.target).closest('a').addClass('hovered');
        }).on('mouseleave blur', function(e) {
            $('.crux-sub-nav__link.model-nav__link a').removeClass('hovered');
        });
    }

    window.addEventListener("popstate", function(e) {
        document.title = getNewPageTile();
        if (e && e.state && e.state.hrefState) {
            prevState = e.state.hrefState;
        }
    });

    if (!isMobilePage()) {
        scrollToSection(window.location.hash);
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ModelNav/modelHashNavigation.js